import React from "react";

export default function FlexSection({ children, extraClass, displayedEvents }) {
  return <div className={` flex   ${extraClass}`}
  style={{minHeight:displayedEvents * 530 }}
  >{children}</div>;
}
